import { ROUTE_PATH as MERCHANT_PATH } from '@/features/merchantsPage/consts';

export const createEditMerchantLink = merchantId =>
  `${MERCHANT_PATH}/${merchantId}/edit`;
